// Librerias
import React from 'react'

export class EsDeRegion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        return (
            <div className="container" style={{textAlign: 'center'}}>
                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <div className="panel panel-danger">
                            <div className="panel-heading">Sin permisos</div>

                            <div className="panel-body">
                                Lo sentimos, esta funcionalidad de momento está disponible sólo para usuarios de ciertas regiones, si está viendo esto es probable que su región no esté disponible actualmente, lamentamos cualquier incoveniente y agradecemos su paciencia.
                            </div>
                        </div>
                    </div>
                </div>
                <button className='btn btn-primary' >
                    <a href='/' style={{color: 'white'}}>Volver</a>
                </button>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/registro-operador/esDeRegion.jsx